import { useContext } from 'react';
import { createContext } from 'react';

import { ProductSellingPriceProps } from '../@types/ProductSellingPriceProps';

export const ProductSellingPriceContext = createContext<ProductSellingPriceProps>({} as ProductSellingPriceProps);

ProductSellingPriceContext.displayName = 'ProductSellingPrice';

const ProductSellingPriceProvider = (props: ProductSellingPriceProps) => (
	<ProductSellingPriceContext.Provider value={props}>{props.children}</ProductSellingPriceContext.Provider>
);

export const useProductSellingPrice = () => {
	const context = useContext(ProductSellingPriceContext);

	return context;
};

export default ProductSellingPriceProvider;
